module.exports = __webpack_public_path__ + "img/peter_h.af3254ce.png";